import { memo, useCallback, useEffect, useState, useId } from 'react';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import AttachIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Close';
// Local files
import { Root } from './Input.styled';
import Uploader from 'components/Blobs/ImageUploader/ImageUploader';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import { checkEmptyString } from 'helpers';
import useMessages from 'hooks/useMessages';
import useCustomSelector from 'hooks/useCustomSelector';
import usePrevious from 'hooks/usePrevious';
import { messagesSelectors } from 'features/messages';
import { conversationsSelectors } from 'features/conversations';

const Input= () => {
  const { createMessage, createLocalMessage, setLocalMessageError } = useMessages();
  const local_id = useId();
  const { id: conversation_id } = useCustomSelector(conversationsSelectors.getConversation);
  const [addFiles, setAddFiles] = useState(false);
  const [medias, setMedias] = useState(null);
  const loading = useCustomSelector(messagesSelectors.messageIsFetching);
  const [text, setText] = useState('');
  const prevPatientId = usePrevious(conversation_id);
  const edit = false;

  const clearFields = useCallback(() => setText(''), []);

  useEffect(() => {
    !!conversation_id && conversation_id !== prevPatientId && clearFields();
  }, [conversation_id, prevPatientId, clearFields]);

  const handleKeyDown = ({ ctrlKey, metaKey, key }) => {
    ctrlKey && key === 'Enter' && handleSendClick();
    metaKey && key === 'Enter' && handleSendClick();
  };
  const handleSendClick = () => {    
    if (checkEmptyString(text) || !!medias) {
      const message = {
        ...(checkEmptyString(text) && { text }),
        ...(!!medias && { medias: [medias.id], localMedias: medias })
      };
      setText('');
      setMedias(null);
      const date = new Date();
      createLocalMessage({ ...message, id: local_id, time: 'pending', sender: 'manager', status: 'newest', created_at: date.toISOString() });
      createMessage({ message, conversation_id, local_id })
      .then(({ error }) => {
        if (error) {
          setLocalMessageError(local_id);
        }
      })
    }
  };

  return (
    <>
      <Root>
        <IconButton disabled={loading} onClick={() => setAddFiles(true)}><AttachIcon /></IconButton>
        <TextField
          fullWidth
          variant='standard'
          InputProps={{ disableUnderline: true }}
          placeholder='Type a message'
          value={text}
          multiline
          maxRows={3}
          onChange={({ target: { value } }) => setText(value)}
          onKeyDown={handleKeyDown}
        />
        {edit ? (<>
          <IconButton disabled={loading}><SendIcon color='primary' /></IconButton>
          <IconButton disabled={loading}><CancelIcon color='primary' /></IconButton>
        </>) : (
          <IconButton disabled={loading} onClick={handleSendClick}><SendIcon color='primary' /></IconButton>
        )}
      </Root>
      <Uploader
        label='Add images'
        id='imageUploader'
        fullWidth
        accept='image/*'
        medias={medias}
        setMedias={(value) => setMedias(value)}
        onDelete={() => setMedias(null)}
        addFiles={addFiles}
        setAddFiles={(value) => setAddFiles(value)}
      />
    </>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Input {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);